import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import { IAttachDocument } from 'src/types/AttachDocument';
import { IPostBody } from 'src/types/PostBody';
import axiosInstance from 'src/utils/axios';

interface AttachDocumentRequest {
  companyId?: string;
  body?: IPostBody;
  uploadsOlderThan90Days?: boolean;
}

interface AttachDocumentResponse {
  totalRecords: number;
  items: IAttachDocument[];
}

const useAttachDocumentApi = (isInvoices: boolean) => {
  const call = useCallback(
    ({ companyId, body, uploadsOlderThan90Days = true }: AttachDocumentRequest = {}) =>
      new Promise<AttachDocumentResponse>((resolve, reject) => {
        axiosInstance
          .post<AttachDocumentResponse>(
            isInvoices
              ? api.getScanInvoiceDataUrlFn(parseInt(companyId || ''), uploadsOlderThan90Days)
              : api.getScanReceiptDataUrlFn(parseInt(companyId || '')),
            body
          )
          .then((data) => {
            resolve({
              totalRecords: data.data.totalRecords,
              items: data.data.items.map((item) => ({ ...item, preview: false })),
            });
          })
          .catch((error) => {
            reject(error);
          });
      }),
    [isInvoices]
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    attachDocument: execute,
    isAttachDocumentLoading: isLoading,
  };
};

export default useAttachDocumentApi;
